import { useState } from "react";

import AppModal from "../AppModal";
import PolicyViewer from "../PolicyViewer";
import PolicyLanguageSelect from "../PolicyLanguageSelect";

const PolicyModal = ({ open, onClose, title, policyUrl }) => {
  const [language, setLanguage] = useState("en");

  return (
    <AppModal
      open={open}
      onClose={onClose}
      maxWidth="1100px"
      showScrollTop={false}
      extraActions={
        <PolicyLanguageSelect value={language} onChange={setLanguage} />
      }
    >
      <PolicyViewer
        title={title}
        policyUrl={policyUrl}
        language={language}
        frameHeight="70vh"
        card={false}
      />
    </AppModal>
  );
};

export default PolicyModal;
